$(document).ready(function(){
  $(document).on('click',".t4s-btn-coupon",function(){
    let text = $(this).data("coupon");
    navigator.clipboard.writeText(text);
    $(this).find(".tooltiptext").text( T4Sstrings.copied_tooltipText + ": " + text);

  })
  $(document).on('mouseleave',".t4s-btn-coupon",function(){
    $(this).find(".tooltiptext").text(T4Sstrings.copy_tooltipText);
   
  })
});

(function () {
  var selectors = ['#shopify-pc__banner', '[data-kl-scroll-locking-modal="true"]'];
  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }
  function syncOverlayState() {
    if (!document.body) return;
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    var open = mobile && selectors.some(function (selector) {
      return Array.prototype.some.call(document.querySelectorAll(selector), isVisible);
    });
    document.body.classList.toggle('m2u-overlay-open', open);
  }
  function ensureEstimateLabels() {
    Array.prototype.forEach.call(document.querySelectorAll('#t4s-mini_cart [data-cart-tool_action][data-id="rates"]'), function (button) {
      if (!button.querySelector('.m2u-cart-tool-label')) {
        var label = document.createElement('span');
        label.className = 'm2u-cart-tool-label';
        label.textContent = button.getAttribute('title') || 'Estimate shipping';
        button.appendChild(label);
      }
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
    });
  }
  function start() {
    syncOverlayState();
    ensureEstimateLabels();
    new MutationObserver(function () {
      syncOverlayState();
      ensureEstimateLabels();
    }).observe(document.documentElement, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
    window.addEventListener('resize', syncOverlayState, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();


(function () {
  if (document.getElementById('m2u-r6-styles')) return;
  var style = document.createElement('style');
  style.id = 'm2u-r6-styles';
  style.textContent = "/* Melatonin2U mobile purchase flow */\n.t4s-swatch__option:has(.t4s-swatch__list > .t4s-swatch__item:only-child) .t4s-swatch__list { display: none !important; }\n.t4s-swatch__option:has(.t4s-swatch__list > .t4s-swatch__item:only-child) .t4s-swatch__title { margin-bottom: 6px !important; }\n.t4s-swatch__option:has(.t4s-swatch__list > .t4s-swatch__item:only-child) .t4s-swatch__current { font-weight: 600; color: #11104f; }\n#t4s-mini_cart .mini_cart_tool_btn.is--rates { width: auto; min-width: 124px; padding: 0 12px; gap: 7px; display: inline-flex; align-items: center; justify-content: center; }\n#t4s-mini_cart .mini_cart_tool_btn.is--rates svg { flex: 0 0 22px; }\n#t4s-mini_cart .m2u-cart-tool-label { display: inline; font-size: 12px; font-weight: 600; white-space: nowrap; }\n\n@media (max-width: 767px) {\n  shopify-chat { display: none !important; }\n  .whatsapp-floating-button { right: 12px !important; bottom: calc(82px + env(safe-area-inset-bottom)) !important; }\n  body.m2u-overlay-open .whatsapp-floating-button,\n  body.m2u-overlay-open .t4s-sticky-atc { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; }\n  [data-kl-scroll-locking-modal=\"true\"] button[aria-label*=\"close\" i] { min-width: 44px !important; min-height: 44px !important; }\n  #t4s-mini_cart .mini_cart_tool_btn.is--rates { min-width: 142px; }\n}\n";
  document.head.appendChild(style);
})();
